import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import Icon from 'components/Icon'
import theme from 'theme'

export const OnboardingFooterNavLink = ({ to, children, ...rest }) => (
  <Link
    css={{
      color: theme.colors.steel[1],

      '&:hover, &:focus': {
        color: theme.colors.steel[0]
      }
    }}
    to={to}
    {...rest}
  >
    {children}
  </Link>
)

OnboardingFooterNavLink.propTypes = {
  children: PropTypes.node.isRequired,
  to: PropTypes.string.isRequired
}

const OnboardingFooterNav = ({ previousLink, children, ...rest }) => {
  return (
    <nav
      css={{
        display: 'grid',
        gap: theme.space[4],
        gridAutoFlow: 'column',
        gridAutoColumns: 'min-content',
        alignItems: 'center',
        marginTop: theme.space[5]
      }}
      {...rest}
    >
      {previousLink && (
        <OnboardingFooterNavLink
          css={{
            display: 'grid',
            gap: theme.space[2],
            alignItems: 'center',
            gridTemplateColumns: 'repeat(2, auto)'
          }}
          to={previousLink}
        >
          <Icon
            css={{
              display: 'inline-block',
              fontSize: theme.fontSizes[3]
            }}
            icon="chevronBack"
          />
          <span>Previous</span>
        </OnboardingFooterNavLink>
      )}
      {children}
    </nav>
  )
}

OnboardingFooterNav.propTypes = {
  previousLink: PropTypes.string,
  children: PropTypes.node
}

export default OnboardingFooterNav
